import { ITokenData } from '../auth/types';
import urls from '../urls';

export async function getTokensFromCode(
  code: string,
  codeVerifier: string
): Promise<ITokenData | undefined> {
  // Dont retry until fallback option is removed
  try {
    const response = await fetch(urls.oauth2Token, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        grantType: 'AUTHORIZATION_CODE',
        code,
        codeVerifier,
      }),
      headers: { 'Content-Type': 'application/json' },
    });

    const body = await response.json();
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`Failed to fetch tokens. ${JSON.stringify(body)}`);
    }

    return body;
  } catch (err) {
    // Swallow exception while old auth flow is still active
    console.error(err);
  }
}

export async function getTokens(): Promise<ITokenData | undefined> {
  // Dont retry until fallback option is removed

  try {
    const response = await fetch(urls.oauth2Token, {
      method: 'POST',
      body: JSON.stringify({ grantType: 'REFRESH_TOKEN' }),
      headers: { 'Content-Type': 'application/json' },
    });

    const body = await response.json();
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`Failed to fetch tokens. ${JSON.stringify(body)}`);
    }

    return body;
  } catch (err) {
    // Swallow exception while old auth flow is still active
    console.error(err);
  }
}
